// src/components/App/index.js
import React, { PropTypes, Component } from 'react';
import { browserHistory } from 'react-router';
import classnames from 'classnames';
import Auth from '../service/auth';
import RaisedButton from 'material-ui/RaisedButton';

class LoginPage extends Component {
  // static propTypes = {}
  // static defaultProps = {}
  // state = {}

  state = {
    errorText: undefined
  }

  login() {
    Auth.login().then(user => {
      browserHistory.push('/')
    }).catch(error => {
      this.setState({errorText: "Kirjautuminen tällä tunnuksella ei ole sallittua."});
    });
  }

  render() {
    const { className, ...props } = this.props;

    var user = Auth.currentUser();
    var actionButton;

    if (user && user != null) {
      actionButton = <RaisedButton primary={true} onTouchTap={() => Auth.logout()} label="Kirjaudu ulos"/>;
    } else {
      actionButton = <RaisedButton primary={true} onTouchTap={() => this.login()} label="Kirjaudu sisään"/>;
    }

    var errorTitle = this.state.errorText ? <h3>{this.state.errorText}</h3> : '';

      return (
        <div style={{width: '100%', height: '100%'}}>
          <div style={{position: 'absolute', top: '50%', left: '45%'}} >
            {errorTitle}
            {actionButton}
          </div>
        </div>
      );
  }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/components/LoginPage.js